import Api from './Api'

export default {
  consultationRequest(data) {
    return Api().post('/wp-admin/admin-ajax.php?action=consultation', data)
  },
}



// WEBPACK FOOTER //
// ./src/js/components/app/services/forms.js